import React, { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import { getCustomTable } from "./happyschoolApi";

// Bảng CHỈ ĐỌC — lọc trực tiếp từ 1 bảng nguồn (vd "Học sinh Toàn Khối 12")
// theo `predicate`. Không lưu dữ liệu riêng, nên luôn khớp bảng gốc; sửa dữ
// liệu phải làm ở bảng gốc.
const HappySchoolFilteredView = ({ schoolId, sourceTableKey, title, icon, predicate }) => {
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!schoolId || !sourceTableKey) return;
    setLoading(true); setError("");
    getCustomTable(schoolId, sourceTableKey)
      .then((d) => {
        setColumns(d.columns || []);
        setRows((d.rows || []).filter(predicate));
      })
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, [schoolId, sourceTableKey]); // eslint-disable-line

  const exportExcel = () => {
    const aoa = [columns.map((c) => c.label), ...rows.map((r) => columns.map((c) => r[c.key] ?? ""))];
    const ws = XLSX.utils.aoa_to_sheet(aoa);
    ws["!cols"] = columns.map((c) => ({ wch: Math.max(10, Math.round((c.width || 120) / 7)) }));
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, title.slice(0, 28));
    XLSX.writeFile(wb, `${title}.xlsx`);
  };

  return (
    <div style={{ padding: 20 }}>
      <h2 style={{ margin: "0 0 4px" }}>{icon} {title}</h2>
      <p style={{ color: "#6b7280", fontSize: 13, marginTop: 0 }}>
        Danh sách lọc tự động từ bảng "Học sinh Toàn Khối 12" — chỉ xem, không sửa được ở đây. Sửa dữ liệu ở bảng gốc.
      </p>

      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center", marginBottom: 12 }}>
        <button type="button" onClick={exportExcel} style={btn2} disabled={rows.length === 0}>⬇ Xuất Excel</button>
        <span style={{ marginLeft: "auto", fontSize: 13, color: "#6b7280" }}>{rows.length} dòng</span>
      </div>
      {error && <p style={{ color: "#dc2626" }}>{error}</p>}

      {loading ? (
        <p>Đang tải...</p>
      ) : (
        <div style={{ overflowX: "auto", border: "1px solid #e5e7eb", borderRadius: 8 }}>
          <table style={{ borderCollapse: "collapse", fontSize: 13, width: "100%" }}>
            <thead>
              <tr>
                <th style={{ ...th, width: 44 }}>#</th>
                {columns.map((col) => (<th key={col.key} style={{ ...th, minWidth: col.width }}>{col.label}</th>))}
              </tr>
            </thead>
            <tbody>
              {rows.length === 0 ? (
                <tr><td colSpan={columns.length + 1} style={{ ...td, textAlign: "center", color: "#9ca3af", padding: 20 }}>Chưa có ai khớp.</td></tr>
              ) : rows.map((r, i) => (
                <tr key={r.id}>
                  <td style={{ ...td, textAlign: "center", color: "#9ca3af" }}>{i + 1}</td>
                  {columns.map((col) => (<td key={col.key} style={td}>{r[col.key] ?? ""}</td>))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

const btn2 = { padding: "8px 14px", background: "#fff", color: "#374151", border: "1px solid #d1d5db", borderRadius: 6, cursor: "pointer", fontWeight: 600, fontSize: 13 };
const th = { border: "1px solid #e5e7eb", padding: "7px 8px", background: "#f9fafb", whiteSpace: "nowrap", textAlign: "left", position: "sticky", top: 0 };
const td = { border: "1px solid #e5e7eb", padding: "4px 8px" };

export default HappySchoolFilteredView;
